import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import e from "./Accessor.js";
import { handlesGroup as s } from "./handleUtils.js";
import { subclass as r } from "./accessorSupport/decorators/subclass.js";

var i = /*#__PURE__*/function () {
  function i() {
    _classCallCheck(this, i);

    this._emitter = new i.EventEmitter(this);
  }

  _createClass(i, [{
    key: "emit",
    value: function emit(t, e) {
      return this._emitter.emit(t, e);
    }
  }, {
    key: "on",
    value: function on(t, e) {
      return this._emitter.on(t, e);
    }
  }, {
    key: "once",
    value: function once(t, e) {
      return this._emitter.once(t, e);
    }
  }, {
    key: "hasEventListener",
    value: function hasEventListener(t) {
      return this._emitter.hasEventListener(t);
    }
  }]);

  return i;
}();

!function (n) {
  var o = /*#__PURE__*/function () {
    function o() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      _classCallCheck(this, o);

      this.target = t, this._listenersMap = null;
    }

    _createClass(o, [{
      key: "clear",
      value: function clear() {
        this._listenersMap && this._listenersMap.clear(), this._listenersMap = null;
      }
    }, {
      key: "emit",
      value: function emit(t, e) {
        var s = this._listenersMap && this._listenersMap.get(t);

        if (!s) return !1;
        var r = this.target || this;
        return _toConsumableArray(s).forEach(function (t) {
          t.call(r, e);
        }), s.length > 0;
      }
    }, {
      key: "on",
      value: function on(t, e) {
        var _this = this;

        if (Array.isArray(t)) {
          var _r = t.map(function (t) {
            return _this.on(t, e);
          });

          return s(_r);
        }

        if (t.indexOf(",") > -1) throw new TypeError("Evented.on() with a comma delimited string of event types is not supported");
        this._listenersMap || (this._listenersMap = new Map());
        var r = this._listenersMap.get(t) || [];
        return r.push(e), this._listenersMap.set(t, r), {
          remove: function remove() {
            var s = _this._listenersMap && _this._listenersMap.get(t) || [],
                r = s.indexOf(e);
            r >= 0 && s.splice(r, 1);
          }
        };
      }
    }, {
      key: "once",
      value: function once(t, e) {
        var s = this.on(t, function (t) {
          s.remove(), e.call(null, t);
        });
        return s;
      }
    }, {
      key: "hasEventListener",
      value: function hasEventListener(t) {
        var e = this._listenersMap && this._listenersMap.get(t);

        return null != e && e.length > 0;
      }
    }]);

    return o;
  }();

  n.EventEmitter = o, n.EventedMixin = function (e) {
    var s = /*#__PURE__*/function (_e) {
      _inherits(s, _e);

      var _super = _createSuper(s);

      function s() {
        var _this2;

        _classCallCheck(this, s);

        _this2 = _super.apply(this, arguments), _this2._emitter = new o();
        return _this2;
      }

      _createClass(s, [{
        key: "destroy",
        value: function destroy() {
          this._emitter.clear();
        }
      }, {
        key: "emit",
        value: function emit(t, e) {
          return this._emitter.emit(t, e);
        }
      }, {
        key: "on",
        value: function on(t, e) {
          return this._emitter.on(t, e);
        }
      }, {
        key: "once",
        value: function once(t, e) {
          return this._emitter.once(t, e);
        }
      }, {
        key: "hasEventListener",
        value: function hasEventListener(t) {
          return this._emitter.hasEventListener(t);
        }
      }]);

      return s;
    }(e);

    return s = t([r("esri.core.Evented")], s), s;
  };

  var h = /*#__PURE__*/function (_e2) {
    _inherits(h, _e2);

    var _super2 = _createSuper(h);

    function h() {
      var _this3;

      _classCallCheck(this, h);

      _this3 = _super2.apply(this, arguments), _this3._emitter = new i.EventEmitter(_assertThisInitialized(_this3));
      return _this3;
    }

    _createClass(h, [{
      key: "destroy",
      value: function destroy() {
        this._emitter.clear();
      }
    }, {
      key: "emit",
      value: function emit(t, e) {
        return this._emitter.emit(t, e);
      }
    }, {
      key: "on",
      value: function on(t, e) {
        return this._emitter.on(t, e);
      }
    }, {
      key: "once",
      value: function once(t, e) {
        return this._emitter.once(t, e);
      }
    }, {
      key: "hasEventListener",
      value: function hasEventListener(t) {
        return this._emitter.hasEventListener(t);
      }
    }]);

    return h;
  }(e);

  h = t([r("esri.core.Evented")], h), n.EventedAccessor = h;
}(i || (i = {}));
var n = i;
export { n as default };